import { Field } from 'formik'
import React, { useEffect } from 'react'

import { ButtonClean, Fieldset, Input } from '@fourthwall/components'

import type { RadioOption } from '../../../../types'
import type { FormValues } from '../../../../utils/FormValues'
import { OptionsDescription, OptionsSection, OptionsTitle } from './forms.styled'

type RadioFormProps = {
  setFieldValue: (field: string, value: any) => void
  values: FormValues
}

export const RadioForm = ({ setFieldValue, values }: RadioFormProps) => {
  const options = values.options || []

  // Ensure there's at least one option
  useEffect(() => {
    if (options.length === 0) {
      setFieldValue('options', [{ value: '', label: '' }])
    }
  }, [options.length, setFieldValue])

  const handleOptionAdd = () => {
    setFieldValue('options', [...options, { value: '', label: '' }])
  }

  const handleOptionRemove = (optionIndex: number) => {
    // Don't allow removing the last option
    if (options.length <= 1) return

    const newOptions = [...options]
    newOptions.splice(optionIndex, 1)
    setFieldValue('options', newOptions)
  }

  const renderOptions = () => {
    return options.map((option: RadioOption, index: number) => (
      <Fieldset.Row key={index}>
        <Fieldset.Item>
          <Field
            name={`options[${index}].value`}
            type="text"
            component={Input}
            label={`Option ${index + 1} Value`}
            defaultValue={option.value}
          />
        </Fieldset.Item>
        <Fieldset.Item>
          <Field
            name={`options[${index}].label`}
            type="text"
            component={Input}
            label={`Option ${index + 1} Label`}
            defaultValue={option.label}
          />
        </Fieldset.Item>
        <Fieldset.Item>
          <ButtonClean label="Remove" onClick={() => handleOptionRemove(index)} />
        </Fieldset.Item>
      </Fieldset.Row>
    ))
  }

  return (
    <>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field name="label" component={Input} label="Label" placeholder="Setting label" />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            name="info"
            component={Input}
            label="Info (optional)"
            placeholder="Help text for this setting"
          />
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Fieldset.Item>
          <Field
            name="default"
            component={Input}
            label="Default Value (optional)"
            placeholder="Default value"
          />
        </Fieldset.Item>
      </Fieldset.Row>

      {/* Options Section */}
      <Fieldset.Row>
        <Fieldset.Item>
          <OptionsSection>
            <OptionsTitle>Options</OptionsTitle>
            <OptionsDescription>
              Add the available options for this radio/select field
            </OptionsDescription>
          </OptionsSection>
        </Fieldset.Item>
      </Fieldset.Row>

      {renderOptions()}

      <Fieldset.Row>
        <Fieldset.Item>
          <ButtonClean onClick={handleOptionAdd} label="Add Option" />
        </Fieldset.Item>
      </Fieldset.Row>
    </>
  )
}
